module.exports = {}


//////////////////
// WEBPACK FOOTER
// ./src/theme/braunsheitmannShop/ortho-field-config-translation.json
// module id = 1235
// module chunks = 0